import { SET_TITLE } from './types';

export const setTitle = (title) => ({
  type: SET_TITLE,
  payload: title,
});
